import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CalculateCoverResponse } from 'src/app/models/calculate-cover-response';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QUICK_QUOTE } from '../apg-beat-your-broker.component';

@Component({
  templateUrl: './cover-calculator.route.html',
  styleUrls: ['./cover-calculator.route.scss'],
})
export class CoverCalculatorRoute implements OnInit {

  constructor(
    @Inject(QUICK_QUOTE) private quickquote$: BehaviorSubject<QQQuestionnaireViewModel>,
    private router: Router
  ) { }

  ngOnInit() {
  }

  onCoverCalculated(result: CalculateCoverResponse) {
    const quote = this.quickquote$.value;
    quote.saveAnswer('CoverBasis_1', result.coverBasis);
    quote.saveAnswer('ProtectionLevel_1', result.sumAssured.toFixed(0));
    quote.saveAnswer('PolicyTerm_1', result.term.toFixed(0));
    quote.saveAnswer('FinancialAllocationType', 'SumAssured')
    quote.saveAnswer('PolicyType_1', 'TERM')
    quote.saveAnswer('CoverSource', 'CoverCalculator')
    quote.currentPage.nextPage();

    this.router.navigate(["/coverchecker"]);
  }

  backToQuickQuote() {
    this.router.navigate(["/coverchecker"]);
  }
}
